import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import BlockOutput from 'content-renderer'
import { Typography } from 'common/typography'
import { useCourse } from 'querys/course'
import useIntersectionObserver from 'hooks/use-intersection-observer'

const CourseTeacherMessageStyled = styled.section`
  margin: 24px 0;
  font: var(--regular);
  ul {
    padding: 0;
    li {
      margin: 0;
      margin-bottom: 1rem;
      &:last-child {
        margin: 0;
      }
      a {
        text-decoration: underline;
      }
    }
  }
  @media (min-width: 768px) {
    margin: 40px 0;
  }
`

function CourseTeacherMessage({ setActive }) {
  const { data: { description: { blocks } } } = useCourse()

  const { ref: descriptionRef } = useIntersectionObserver({
    onIntersect: () => setActive('descripcion'),
    rootMargin: '-100px 0px -100px 0px',
  })

  return (
    <CourseTeacherMessageStyled aria-labelledby="to-learn" ref={descriptionRef}>
      <Typography small="headline5" large="headline6" color="var(--baseNeutral)" id="to-learn">
        Qué aprenderás
      </Typography>
      {
        blocks && (
          <BlockOutput
            color="var(--paragraphColor)"
            chunks={blocks}
          />
        )
      }
    </CourseTeacherMessageStyled>
  )
}

CourseTeacherMessage.propTypes = {
  setActive: PropTypes.func.isRequired,
}

export default CourseTeacherMessage
